/* Astrogames — aparición al hacer scroll (sin librerías) */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var MAX_STAGGER = 8, STEP = 40;

  function setup() {
    var targets = [];
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    // en móvil/tablet no se animan secciones enteras (capas gigantes = más memoria en iPhone)
    var small = window.matchMedia('(max-width: 989px)').matches;
    if (!small) sections.forEach(function (sec, i) { if (i > 0) targets.push(sec); });
    document.querySelectorAll('#ResultsList .gaming-card').forEach(function (c) { targets.push(c); });

    var io = new IntersectionObserver(function (entries) {
      var batch = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.style.transitionDelay = (Math.min(batch++, MAX_STAGGER) * STEP) + 'ms';
        el.classList.add('is-in');
        setTimeout(function () {
          el.classList.remove('ag-reveal', 'is-in');
          el.style.transitionDelay = '';
        }, 700);
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' }); // equivale a ~12% visible incluso en secciones muy altas

    targets.forEach(function (el) {
      // lo que ya está a la vista al cargar no se oculta ni se anima (evita parpadeos en equipos lentos)
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) return;
      el.classList.add('ag-reveal'); io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();

/* Libera la capa de desenfoque de las tarjetas que están lejos de la pantalla (menos memoria en iPhone) */
(function () {
  if (!('IntersectionObserver' in window) || !window.matchMedia('(max-width: 989px)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
  }, { rootMargin: '400px 400px 400px 400px' });
  var pending = false;
  function watch() {
    pending = false;
    document.querySelectorAll('.gaming-card:not([data-ag-w])').forEach(function (c) { c.setAttribute('data-ag-w', '1'); io.observe(c); });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(watch); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
